<template>
  <div>
    <form
      class="uk-search task-add-form uk-search-large"
      method="post"
      @submit="submitTask()"
      action="javascript:void(0)"
    >
      <textarea
        class="uk-search-input new-task-input"
        type="text"
        v-model="newTask"
        :style="{ height: newTaskHeight + 'px' }"
        placeholder=".."
      ></textarea>
      <savebutton action="submitTask" />
      <div></div>
    </form>
    <div class="text-xs mt-2">Hazır Görevler:</div>
    <div class="flex mt-2 space-x-1 items-center">
      <div v-for="template in tasks_templates">
        <button
          type="button"
          class="global-button"
          @click="bulkInsert(template)"
        >
          {{ template.name }}
        </button>
      </div>
    </div>

    <div class="border-b border-gray-200 mb-2  dark:border-gray-700">
      <nav
        class="flex space-x-2 overflow-x-scroll md:overflow-hidden"
        aria-label="Tabs"
        role="tablist"
      >
        <button
          type="button"
          :class="{ ' border-tile-500 text-tile-500': 'gorevler' == activeTab }"
          class="py-4 px-1 inline-flex items-center gap-x-2 border-b-2 border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-tile-500 disabled:opacity-50 disabled:pointer-events-none"
          id="tab-gorevler"
          @click="changeTab('gorevler')"
          data-hs-tab="#gorevler"
          aria-controls="gorevler"
          role="tab"
        >
          GÖREVLER
        </button>
        <button
          type="button"
          :class="{
            ' border-tile-500 text-tile-500':
              'tamamlanmis-gorevler' == activeTab
          }"
          class="py-4 px-1 inline-flex items-center gap-x-2 border-b-2 border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-tile-500 disabled:opacity-50 disabled:pointer-events-none"
          id="tab-tamamlanmis-gorevler"
          @click="changeTab('tamamlanmis-gorevler')"
          data-hs-tab="#tamamlanmis-gorevler"
          aria-controls="tamamlanmis-gorevler"
          role="tab"
        >
          TAMAMLANMIŞ GÖREVLER
        </button>
      </nav>
    </div>

    <div v-if="activeTab === 'gorevler'" class="task-list mt-4">
      <transition-group name="company" tag="ul">
        <div
          class="shadow rounded-lg  p-2 mb-2"
          v-if="task.status == 0"
          v-bind:key="task.id"
          v-for="task in tasks"
        >
          <div
            class="flex items-center justify-between space-x-2"
            :class="{ completed: task.status == 1 }"
          >
            <div>
              <span class="checkbox">
                <input
                  class="uk-checkbox"
                  @click="taskUpdate(task)"
                  true-value="1"
                  false-value="0"
                  v-model="task.status"
                  type="checkbox"
                />
              </span>

              <span class="task-title">
                {{ task.title }}
              </span>
            </div>

            <div class="flex items-center">
              <router-link
                v-if="task.lead_id > 0"
                class="text-sm task-title"
                :to="'/leadDetail/' + task.lead_id"
              >
                #LEAD{{ task.lead_id }}
              </router-link>

              <span @click="detailTask(task)" class="cursor-pointer">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M12.25 12h-.5m.5-4h-.5m.5 8h-.5"
                  />
                </svg>
              </span>
            </div>
          </div>
        </div>
      </transition-group>
    </div>

    <div v-if="activeTab === 'tamamlanmis-gorevler'" class="task-list mt-4">
      <div
        class="shadow rounded-lg  p-2 mb-2"
        v-if="task.status == 1"
        v-bind:key="task.id"
        v-for="task in tasks"
      >
        <div
          class="flex items-center justify-between space-x-2"
          :class="{ completed: task.status == 1 }"
        >
          <div>
            <span class="checkbox">
              <input
                class="uk-checkbox"
                @click="taskUpdate(task)"
                true-value="1"
                false-value="0"
                v-model="task.status"
                type="checkbox"
              />
            </span>

            <span class="task-title">
              {{ task.title }}
            </span>
          </div>

          <div class="flex items-center">
            <span class="date text-sm" title="Tamamlandığı tarih">{{
              task.complete_date
            }}</span>
            <span @click="detailTask(task)" class="cursor-pointer">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  d="M12.25 12h-.5m.5-4h-.5m.5 8h-.5"
                />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>

    <vk-offcanvas-content class="task-canvas">
      <vk-offcanvas flipped :show.sync="taskDetailShow">
        <template v-if="taskDetail.info">
          <vk-offcanvas-close
            @click="taskDetailShow = false"
          ></vk-offcanvas-close>
          <h3>
            <input
              class="uk-checkbox"
              true-value="1"
              false-value="0"
              v-model="taskDetail.info.status"
              type="checkbox"
            />
            {{ taskDetail.info.title }}
          </h3>

          <form
            method="post"
            action="javascript:void(0)"
            @submit="updateTask(taskDetail.info, taskDetail.agents)"
          >
            <multiselect
              v-model="taskDetail.agents"
              v-if="$root.cache.getOptions[15]"
              :options="$root.cache.getOptions[15]"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Pick some"
              label="label"
              track-by="label"
              :preselect-first="true"
            >
            </multiselect>
            <div class="uk-margin">
              <textarea
                class="uk-textarea"
                v-model="taskDetail.info.description"
              ></textarea>
            </div>
            <div class="uk-margin">
              <savebutton action="updateTask" />
            </div>
          </form>

          <div class="sub_tasks">
            <h5>Alt görevler</h5>
            <form
              @submit="submitSubTask(taskDetail.info.id)"
              action="javascript:void(0)"
              method="post"
            >
              <input
                class="uk-input"
                type="text"
                v-model="newSubTask"
                placeholder="Yeni bir görev ..."
              />
            </form>
            <ul class="task-list" v-if="taskDetail.info.id">
              <li class="task-li" v-for="task in subtask">
                <div v-bind:class="{ completed: task.status == 1 }">
                  <span class="checkbox">
                    <input
                      class="uk-checkbox"
                      true-value="1"
                      false-value="0"
                      v-model="task.status"
                      type="checkbox"
                    />
                  </span>
                  <span class="task-title">{{ task.title }}</span>
                </div>
              </li>
            </ul>
          </div>
        </template>
      </vk-offcanvas>
    </vk-offcanvas-content>
  </div>
</template>

<script>
import EventBus from "../EventBus";
import taskService from "../../../services/task";

import Multiselect from "vue-multiselect";
import http from "../../../services/http";
export default {
  data() {
    return {
      journals: [],
      loading: true,
      tasks: [],
      newTaskHeight: 100,
      taskDetailShow: false,
      activeTab: "gorevler",
      taskDetail: [],
      loading: [],
      subtask: [],
      newSubTask: null,
      tasks_templates: [],

      newTaskEnterType: 1,
      newTask: null
    };
  },
  props: ["id", "fieldsMap"],
  components: {
    multiselect: Multiselect
  },
  mounted() {
    this.getTasks();

    http.getData({ table: "tasks_templates" }).then(e => {
      this.tasks_templates = e.data.results;
    });
  },
  methods: {
    changeTab(tab) {
      this.activeTab = tab;
    },
    taskUpdate(task) {
      if (task.status == 1) {
        task.status = 0;
      } else {
        task.status = 1;
      }
      this.updateTaskStatus(task);
    },
    updateTaskStatus(info) {
      EventBus.$emit("loadingStatus", {
        action: "updateTask",
        loading: true
      });

      taskService.taskStatus(info).then(e => {
        if (e.data.success == true) {
          EventBus.$emit("loadingStatus", {
            action: "updateTask",
            loading: false,
            success: true
          });
        } else {
          EventBus.$emit("loadingStatus", {
            action: "updateTask",
            loading: false,
            success: false
          });
        }
      });
    },
    detailTask(detail) {
      this.taskDetailShow = false;
      setTimeout(() => {
        this.taskDetailShow = true;
      }, 100);

      this.getSubTasks(detail.id);
    },
    getSubTasks(id) {
      taskService.tasks({ parent_id: id }).then(e => {
        this.subtask = e.data.results;
        this.taskDetail = e.data;
      });
    },
    bulkInsert(template) {
      this.newTask = template.tasks;
      this.submitTask();
    },
    submitTask() {
      EventBus.$emit("loadingStatus", { action: "submitTask", loading: true });
      taskService
        .taskAdd({ title: this.newTask, parent_id: 0, lead_id: this.id })
        .then(e => {
          if (e.data.success) {
            this.getTasks();
            EventBus.$emit("loadingStatus", {
              action: "submitTask",
              loading: false,
              success: true
            });
          } else {
            EventBus.$emit("loadingStatus", {
              action: "submitTask",
              loading: false,
              success: false
            });
          }

          this.newTask = null;
        });
    },
    getTasks() {
      taskService.tasks({ parent_id: 0, lead_id: this.id }).then(e => {
        this.tasks = e.data.results;
      });
    }
  }
};
</script>

<style>
.journal-list li {
  display: block;
}

.journal-table {
  background: #fff;
  border-top: none;
  margin-top: 0px;
}
</style>
